





























































































































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import Controls from "@/components/vue-components/Controls.vue";
import { mapGetters, mapActions } from "vuex";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";

export default Vue.extend({
  name: "Login",
  components: {
    vIcon,
    Controls,
    VelloIcon
  },
  data: () => {
    return {
      userState: false as boolean,
      companyID: "" || undefined,
      email: "" as string,
      password: "" as string,
      status: "base" as string,
      errors: {
        email_missing: false,
        email_incorrect: false,
        password_missing: false,
        password_incorrect: false
      } as { [key: string]: boolean }
    };
  },
  computed: {
    ...mapGetters([
      "GET_CSRF_INFORMATION",
      "GET_USER_STATUS",
      "COMPANY_GET_COMPANY"
    ])
  },
  methods: {
    ...mapActions([
      "USER_LOGIN",
      "UPDATE_DIALOG_STATUS",
      "COMPANY_FETCH_COMPANY",
      "UPDATE_NOTIFICATION_STATUS"
    ]),

    handleClickRegister(): void {
      this.$router.push({ name: "Register" });
    },

    handleFormSubmit(): void {
      this.status = "loading";
      if (this.preValidateFormData()) {
        this.$store
          .dispatch("USER_LOGIN", {
            credentials: {
              email: this.email,
              password: this.password
            },
            token: this.GET_CSRF_INFORMATION.token
          })
          .then(() => {
            return this.$store.dispatch("COMPANY_FETCH_COMPANY", {
              id: this.GET_USER_STATUS.user._default_company,
              token: this.GET_CSRF_INFORMATION.token
            });
          })
          .then(() => {
            setTimeout(() => {
              this.status = "done";
              this.$gtag.event("login", {
                event_category: "engagement",
                event_label: "method"
              });
            }, 500);
            setTimeout(() => {
              window.location.replace(
                `${process.env.VUE_APP_VELLO_URL}/${this.COMPANY_GET_COMPANY.companyUrl}`
              );
            }, 500);
          })
          .catch(error => {
            if (error.message === "Username or password is incorrect.") {
              this.errors.email_incorrect = true;
              this.errors.password_incorrect = true;
            }
            if (error.message === "Maximum login attempts exceeded.") {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "cooldown"
              });
            }
            this.status = "base";
          });
      } else {
        this.status = "base";
      }
    },

    preValidateFormData(): boolean {
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));
      !this.email && (this.errors.email_missing = true);
      !this.password && (this.errors.password_missing = true);
      return Object.keys(this.errors).every(key => !this.errors[key]);
    },

    handleForgotClick(): void {
      this.$store.dispatch("UPDATE_DIALOG_STATUS", {
        status: true,
        component: "requestResetPassword"
      });
    },

    // handleLoginOffice365(): void {
    //   process.env.VUE_APP_AZURE_URL
    //     ? (window.location.href = process.env.VUE_APP_AZURE_URL)
    //     : null;
    // },

    // handleLoginGoogle(): void {
    //   process.env.VUE_APP_GOOGLE_URL
    //     ? (window.location.href = process.env.VUE_APP_GOOGLE_URL)
    //     : null;
    // },

    handleClickLogout(): void {
      this.$router.push({ name: "Logout" });
    },

    handleClickCancel(): void {
      history.go(-1);
    },

    _Temp_handleAllreadLoggedIn(): void {
      this.$store
        .dispatch("COMPANY_FETCH_COMPANY", {
          id: this.GET_USER_STATUS.user._default_company,
          token: this.GET_CSRF_INFORMATION.token
        })
        .then(() => {
          window.location.replace(
            `${process.env.VUE_APP_VELLO_URL}/${this.COMPANY_GET_COMPANY.companyUrl}`
          );
        });
    }
  },
  mounted() {
    this.userState = this.GET_USER_STATUS.status;
    this.companyID = this.GET_USER_STATUS.user?._default_company
      ? this.GET_USER_STATUS.user._default_company
      : undefined;
    if (this.userState && this.companyID) this._Temp_handleAllreadLoggedIn();
  }
});
